'use strict';

var _require = require('./util'),
    get = _require.get,
    is = _require.is,
    arr = _require.arr,
    num = _require.num,
    px = _require.px,
    breaks = _require.breaks,
    dec = _require.dec,
    media = _require.media,
    merge = _require.merge;

var _require2 = require('./constants'),
    fontSizes = _require2.fontSizes;

module.exports = function (props) {
  var n = is(props.fontSize) ? props.fontSize : props.fontSize || props.f;
  if (!is(n)) return null;

  var scale = get(props, 'theme.fontSizes', fontSizes);

  if (!Array.isArray(n)) {
    return {
      fontSize: fx(scale)(n)
    };
  }

  var bp = breaks(props);

  return n.map(fx(scale)).map(dec('fontSize')).map(media(bp)).reduce(merge, {});
};

var fx = function fx(scale) {
  return function (n) {
    return num(n) ? px(scale[n] || n) : n;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/font-size.js
// module id = 378
// module chunks = 168707334958949